// Theme configuration matching Flutter frontend
// Flutter colors: primaryColor: 0xFF008080 (Teal), backgroundColor: 0xFFF8F9FA
// Font: Roboto (Google Fonts)

export const theme = {
  colors: {
    // Primary colors - matching Flutter
    primary: '#008080',        // Teal - same as Flutter primaryColor
    primaryDark: '#006666',    // Darker teal - same as Flutter secondaryColor
    primaryLight: '#00A0A0',   // Lighter teal variation
    accent: '#FF0000',         // Red accent - same as Flutter accentColor
    
    // Background colors - Dark theme for dashboard
    background: '#1A1A1A',     // Dark background for dashboard
    backgroundLight: '#2D2D2D', // Slightly lighter for cards
    backgroundDark: '#0F0F0F',  // Even darker for contrast
    
    // Text colors — dark theme (dashboard backgrounds)
    textPrimary: '#FFFFFF',    // White for dark background
    textSecondary: '#B0B0B0',  // Light gray for secondary text
    textTertiary: '#808080',   // Medium gray for tertiary text
    // Text colors — light theme (white-background panels, slide-out drawers, modals)
    // Prefixed 'panel' so dark-theme components cannot accidentally pick these up.
    panelText: '#111827',      // Near-black for headings on white
    panelBody: '#374151',      // Dark grey for body/data rows on white
    panelMuted: '#6b7280',     // Medium grey for secondary labels on white
    
    // UI elements
    border: '#3D3D3D',         // Border color for dark theme
    divider: '#2D2D2D',        // Divider lines
    
    // Status colors
    success: '#4CAF50',        // Green - matching Flutter
    error: '#E91E63',          // Pink/Red - matching Flutter
    warning: '#FFC107',        // Amber
    info: '#2196F3',           // Blue - matching Flutter
    
    // Card and tile colors
    cardBackground: '#2D2D2D',
    cardHover: '#3D3D3D',
    tileGradient: 'linear-gradient(135deg, #008080 0%, #006666 100%)',
  },
  
  fonts: {
    // Roboto font family - matching Flutter
    primary: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Roboto', sans-serif",
    body: "'Roboto', sans-serif",
    mono: "'Roboto Mono', monospace",
  },
  
  fontSizes: {
    // Font sizes matching Flutter scale
    xs: '0.75rem',     // 12px
    sm: '0.875rem',    // 14px
    base: '1rem',      // 16px
    lg: '1.125rem',    // 18px
    xl: '1.25rem',     // 20px - matching Flutter appBar title
    '2xl': '1.5rem',   // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem',  // 36px - main heading
    '5xl': '3rem',     // 48px
  },
  
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.3)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.4)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.5)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.6)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.4)',
    teal: '0 4px 14px 0 rgba(0, 128, 128, 0.4)',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    medium: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
  
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },
};
